import { useTranslation } from "react-i18next";
import { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { translatePath } from "../lib/langRoutes";

const LANGS = [
  { code: "de", label: "DE" },
  { code: "pt", label: "PT" },
  { code: "en", label: "EN" },
];

export const LanguageSwitcher = ({ variant = "light" }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const activeCode = i18n.language?.split("-")[0] || "de";
  const current = LANGS.find((l) => l.code === activeCode) || LANGS[0];
  const baseText = variant === "dark" ? "text-[#F6F5F2]" : "text-[#3E5239]";
  const hover = variant === "dark" ? "hover:text-[#A7CA99]" : "hover:text-[#A7CA99]";

  const onPick = (code) => {
    setOpen(false);
    // Compute the equivalent path in the target language (handles /pt, /en, DE root
    // and the localized prices slug preise/precos/prices) and navigate there.
    const target = translatePath(pathname, code);
    i18n.changeLanguage(code);
    navigate(target);
  };

  return (
    <div ref={ref} className="relative" data-testid="lang-switcher">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="lang-switcher-toggle"
        className={`flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] ${baseText} ${hover} transition-colors`}
      >
        {current.label}
        <span className="text-[10px] opacity-60">▾</span>
      </button>
      {open && (
        <div
          data-testid="lang-switcher-menu"
          className="absolute right-0 top-full mt-3 min-w-[80px] bg-[#F6F5F2] border border-[#E4E2DA] shadow-sm py-1"
        >
          {LANGS.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => onPick(l.code)}
              data-testid={`lang-option-${l.code}`}
              className={`block w-full text-left px-4 py-2 text-xs uppercase tracking-[0.18em] transition-colors ${
                l.code === current.code
                  ? "text-[#3E5239] bg-[#A7CA99]/15"
                  : "text-[#6B7A66] hover:bg-[#A7CA99]/10 hover:text-[#3E5239]"
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
